module.exports = __webpack_public_path__ + "img/1_1_m.ef1d68ab.jpg";